<template flat>
  <v-card-actions class="d-flex justify-center">
    <v-bottom-navigation
      v-model="value"
      max-width="130"
      v-for="(item, index) in btnNav"
      :key="index"
      class="grey lighten-3"
      style="box-shadow: none"
    >
      <v-btn class="grey lighten-3" @click="insertRoute(item.to)">
        <span class="text-body-2 text-capitalize">{{ item.name }}</span>
        <v-icon class="primary--text" size="30">{{ item.icon }}</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-card-actions>
</template>

<script>
export default {
  name: 'VBottomNav',
  props: ['btnNav'],
  data() {
    return {
      value: 'recent',
    };
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
  },
};
</script>
